import { useEffect, useRef, useContext, useState } from "react"
import PlannedServices3 from "../Forms/B/PlannedServices/PlannedServices3"
import { GpraContext } from "../../../context/gpraContext"
import { endpoints } from "../../../config/gpraApiEndpoints"
import { showMessage } from "../utils/utils"
import { LoaderMedium } from "../../../components/Loaders"
import { INTERVIEW_SECTIONS } from "../types/interviewTypes"
import { UserContext } from "../../../context/userContext"

const PlannedServices3Container = ({ showToolBar, disabled, interview_id }) => {
  const { interview, handleSubmitGet, handleLoadPrev, loadCollection } =
    useContext(GpraContext)
  const userCtx = useContext(UserContext)
  const [isGettingPlannedServices, setIsGettingPlannedServices] = useState(true)

  const toast = useRef()

  useEffect(() => {
    setIsGettingPlannedServices(true)
    if (
      interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id ||
      interview_id
    ) {
      handleSubmitGet(endpoints.GET_PLANNED_SERVICES_DATA, {
        gpra_interview_id: interview_id
          ? interview_id
          : interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          organization_id: userCtx.session.user.organization_id,
        section: INTERVIEW_SECTIONS.PLANNED_SERVICES_3,
      })
        .then((response) => {
          loadCollection(
            setValues(response.data),
            INTERVIEW_SECTIONS.PLANNED_SERVICES_3
          )
          handleLoadPrev(false)
          setIsGettingPlannedServices(false)
        })
        .catch((error) => {
          showMessage(false, error, toast)
          handleLoadPrev(false)
          setIsGettingPlannedServices(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setValues = (data) => {
    return {
      gpra_b_services_cm_1: data?.form?.gpraBServicesCm1 ?? undefined,
      gpra_b_services_cm_2: data?.form?.gpraBServicesCm2 ?? undefined,
      gpra_b_services_cm_3a: data?.form?.gpraBServicesCm3a ?? undefined,
      gpra_b_services_cm_3b: data?.form?.gpraBServicesCm3b ?? undefined,
      gpra_b_services_cm_4: data?.form?.gpraBServicesCm4 ?? undefined,
      gpra_b_services_cm_5: data?.form?.gpraBServicesCm5 ?? undefined,
      gpra_b_services_cm_6a: data?.form?.gpraBServicesCm6a ?? undefined,
      gpra_b_services_cm_6b: data?.form?.gpraBServicesCm6b ?? undefined,
      gpra_b_services_cm_6c: data?.form?.gpraBServicesCm6c ?? undefined,
      gpra_b_services_cm_7: data?.form?.gpraBServicesCm7 ?? undefined,
      gpra_b_services_cm_8: data?.form?.gpraBServicesCm8 ?? undefined,
      gpra_b_services_cm_9: data?.form?.gpraBServicesCm9 ?? undefined,
      gpra_b_services_cm_10: data?.form?.gpraBServicesCm10 ?? undefined,
      gpra_b_services_cm_10a: data?.form?.gpraBServicesCm10a ?? "",
      gpra_b_services_ms_1: data?.form?.gpraBServicesMs1 ?? undefined,
      gpra_b_services_ms_2: data?.form?.gpraBServicesMs2 ?? undefined,
      gpra_b_services_ms_3: data?.form?.gpraBServicesMs3 ?? undefined,
      gpra_b_services_ms_4: data?.form?.gpraBServicesMs4 ?? undefined,
      gpra_b_services_ms_5: data?.form?.gpraBServicesMs5 ?? undefined,
      gpra_b_services_ms_6: data?.form?.gpraBServicesMs6 ?? undefined,
      gpra_b_services_ms_7: data?.form?.gpraBServicesMs7 ?? undefined,
      gpra_b_services_ms_8: data?.form?.gpraBServicesMs8 ?? undefined,
      gpra_b_services_ms_8a: data?.form?.gpraBServicesMs8a ?? "",
      gpra_b_services_acs_1: data?.form?.gpraBServicesAcs1 ?? undefined,
      gpra_b_services_acs_2: data?.form?.gpraBServicesAcs2 ?? undefined,
      gpra_b_services_acs_3: data?.form?.gpraBServicesAcs3 ?? undefined,
      gpra_b_services_acs_4: data?.form?.gpraBServicesAcs4 ?? undefined,
      gpra_b_services_acs_5: data?.form?.gpraBServicesAcs5 ?? undefined,
      gpra_b_services_acs_6: data?.form?.gpraBServicesAcs6 ?? undefined,
      gpra_b_services_acs_6a: data?.form?.gpraBServicesAcs6a ?? "",
      gpra_b_services_id: data?.form?.gpraBServicesId ?? 0,
      additional: data?.additional,
    }
  }
  if (isGettingPlannedServices) {
    return <LoaderMedium></LoaderMedium>
  }
  return (
    <>
      {!isGettingPlannedServices && (
        <PlannedServices3 showToolBar={showToolBar} disabled={disabled} />
      )}
    </>
  )
}
export default PlannedServices3Container
